<template>
  <v-dialog
    v-model="isOpenModal"
    :scrim="false"
    fullscreen
    transition="slide-x-transition"
    @click:outside="onClose"
  >
    <v-card class="left-vertical-card">
      <div class="d-flex bg-titre flex-column pl-3 pt-2">
        <div class="d-flex justify-space-between align-center">
          <div
            class="secondary--text align-self-center titre-h3"
          >
            Tréso moisson
          </div>
          <v-btn
            class="align-self-center"
            text
            @click="onClose"
          >
            <v-icon color="secondary">
              mdi-close
            </v-icon>
          </v-btn>
        </div>
      </div>
      <BaseLoader v-if="loading.detailsContrat" />
      <div
        v-else
        class="d-flex flex-column ma-4"
      >
        <div
          class="d-flex pt-2 justify-space-between"
        >
          <span class="intro texte-gris-fonce py-3">
            Poids engagé
          </span>
          <span class="titre-h4 py-2 align-end secondary--text">
            {{ quantiteTresoMoissonTotal / 1000 | roundNumber(2) }} t
          </span>
        </div>
        <v-divider v-if="quantiteTresoMoissonTotal !== resumeContrat.quantiteTresoMoissonLivreeSansFixationEnKg" />
        <div
          v-if="quantiteTresoMoissonTotal !== resumeContrat.quantiteTresoMoissonLivreeSansFixationEnKg"
          class="d-flex pt-2 justify-space-between"
        >
          <span class="intro texte-gris-fonce py-3">
            Poids livré 
          </span>
          <span class="titre-h4 py-2 align-end secondary--text">
            {{ resumeContrat.quantiteTresoMoissonLivreeSansFixationEnKg / 1000 | roundNumber(2) }} t
          </span>
        </div>
        <v-divider />
        <div
          v-if="detailsContrat.reglements.length"
          class="d-flex flex-column pt-2 mb-3"
        >
          <span class="intro texte-gris-fonce py-2">
            Règlement{{ detailsContrat.reglements.length > 1 ? 's' : '' }}
          </span>
          <div
            v-for="(reglement, index) in detailsContrat.reglements"
            :key="index"
            class="d-flex my-1 justify-space-between"
          >
            <span
              class="texte texte-gris-fonce type-reglement"
            >
              {{ reglement.libelleTypeReglement }}
            </span>
            <span class="texte secondary--text date-reglement ">
              {{ reglement.dateReglement | date('dd/MM/yyyy') }}
            </span>
            <div class="d-flex">
              <v-chip
                :color="getChipColor(reglement.prixReglementEnEuroParTonne)"
                class="d-flex chip justify-center"
                close-icon="mdi-delete"
                label
                small
              >
                <span class="texte --text-white">
                  {{ formatPrixReglement(reglement.prixReglementEnEuroParTonne, 1, '€/t') }}
                </span>
              </v-chip>
              <div v-if="atLeastOneReglementsHaveTooltipIcon">
                <v-tooltip
                  v-if="reglement.quantiteReglementEnKg !== detailsContrat.quantitePayeEnKg"
                  bottom
                >
                  <template v-slot:activator="{ on }">
                    <v-icon
                      class="icon"
                      v-on="on"
                    >
                      mdi-information-outline
                    </v-icon>
                  </template>
                  Valeur sur {{ reglement.quantiteReglementEnKg / 1000 | roundNumber(2) }} t
                </v-tooltip>
              </div>
            </div>
          </div>
        </div>
        <v-divider v-if="detailsContrat.reglements.length" />
        <div class="d-flex pt-2 justify-space-between">
          <span class="intro texte-gris-fonce py-3">
            Logistique
          </span>
          <span class="titre-h4 py-2 align-end secondary--text">
            {{ detailsContrat.type.logistique | capitalize }}
          </span>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import BaseLoader from '@/components/common/base-loader.vue'
import {round} from 'lodash'
import {sommeDesNombresDefinis} from '@/utils/math'

export default {
  name: 'DetailsContratTresoMoissonAFixerModal',
  components: { BaseLoader},
  props: {
    resumeContrat: {
      type: Object,
      required: true
    },
    isOpenModalTresoMoissonAFixerDetails: {
      type: Boolean,
      default: false
    },
  },

  data () {
    return {
      isOpenModal: false,
      loading: {
        detailsContrat: false,
      },
      erreur: {
        detailsContrat: false
      },
    }
  },

  computed: {
    ...mapGetters({
      detailsContrat: 'contrat/detailsContrat'
    }),

    atLeastOneReglementsHaveTooltipIcon () {
      return this.detailsContrat.reglements.some(reglement => reglement.quantiteReglementEnKg !== this.detailsContrat.quantitePayeEnKg)
    },
    //TRESO MOISSON
    quantiteTresoMoissonTotal () {
      //Poids engagé
      return Number(sommeDesNombresDefinis(
       this.resumeContrat.quantiteTresoMoissonFixerEnKg,
        + this.quantiteTresoMoissonAFixer))
    },

    quantiteTresoMoissonAFixer () {
      return Number(sommeDesNombresDefinis(
       this.resumeContrat.quantiteTresoMoissonLivreeSansFixationEnKg,
        + this.resumeContrat.quantiteTresoMoissonEngageAFixerEnKg,
        - this.resumeContrat.quantiteTresoMoissonEnAttenteEnKg))
    },
  },

  created () {
    this.isOpenModal = this.isOpenModalTresoMoissonAFixerDetails
    this.loadDetailsContrat()
  },

  methods: {
    ...mapActions({
      getDetailsContrat: 'contrat/getDetailsContrat'
    }),

    loadDetailsContrat () {
      this.loading.detailsContrat = true
      this.erreur.detailsContrat = false

      return this.getDetailsContrat(this.resumeContrat)
        .catch(() => this.erreur.detailsContrat = true)
        .finally(() => this.loading.detailsContrat = false)
    },

    formatPrixReglement (valeur, precision, unite) {
      let formatted = ''

      if (valeur >= 0) {
        formatted += '+ '
      }
      formatted += round(valeur, precision)
      formatted += ' ' + unite
      return formatted
    },

    getChipColor (valeur) {
      if (valeur >= 0) {
        return 'secondary'
      } else {
        return '#EC6608'
      }
    },
    onClose () {
      this.$emit('close')
    },
  }
}
</script>

<style lang="scss" scoped>
.left-vertical-card {
  border-radius: 0 !important;
}

.bg-titre {
  height: 70px;
  background-color: #f1f2f5;
}

.chip {
  width: 95px;
}

.type-reglement {
  width: 95px;
}

.date-reglement {
  width: 85px;
}

.icon {
  width: 23px;
  height: 20px;
}

.align-end {
  text-align: end;
}
</style>
